import type { FC, ReactNode } from 'react';

import { Fragment } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create({
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    minWidth: 280,
  },
  container: {
    containerName: 'masonry',
    containerType: 'inline-size',
    width: '100%',
  },
  root: {
    '@container (width < 900px)': {
      // 1 columns on mobile
      '& > div:nth-child(1)': {
        order: 2,
      },
      '& > div:nth-child(2)': {
        // show the 2nd column at the end
        order: 3,
      },
      '& > div:nth-child(3)': {
        // show the 3rd column 1st
        order: 1,
      },
      'gridTemplateColumns': '1fr',
    },
    '@container (width < 1300px)': {
      '& > div:nth-child(1)': {
        order: 1,
      },
      '& > div:nth-child(2)': {
        // show the 2nd column at the end
        order: 3,
      },
      '& > div:nth-child(3)': {
        order: 2,
      },
      // 2 columns on tablets
      'gridTemplateColumns': 'repeat(2, 1fr)',
    },
    'display': 'grid',

    'gap': '1.5rem',
    'gridTemplateColumns': 'repeat(3, 1fr)',
  },
});

type Props = {
  columns: [ReactNode[], ReactNode[], ReactNode[]];
};

export const IpenMasonryLayout: FC<Props> = ({ columns }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        {columns.map((column, i) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <div className={classes.column} key={i}>
            {column.map((item, j) => (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <Fragment key={j}>{item}</Fragment>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
